import type { ResumeDocument } from "@/types/cv";
import { IdentityStep } from "./identity-step";
import { ExperienceStep } from "./experience-step";
import { EducationStep } from "./education-step";
import { SkillsStep } from "./skills-step";

export type StepComponentProps = {
  resume: ResumeDocument;
  onChange: (next: ResumeDocument) => void;
};

export const CV_BUILDER_STEPS = [
  { key: "identity", title: "Data diri", Component: IdentityStep },
  { key: "experience", title: "Pengalaman", Component: ExperienceStep },
  { key: "education", title: "Pendidikan", Component: EducationStep },
  { key: "skills", title: "Skill & bahasa", Component: SkillsStep },
] as const;
